import { CROSS_SELL_ERROR, CROSS_SELL_SUCCESS, CROSS_SELL_REQUEST, } from '../types';
export const addCrossSellRequest = (lineItemsAttributes) => ({
    type: CROSS_SELL_REQUEST,
    data: lineItemsAttributes,
});
export const addCrossSellSuccess = (response) => ({
    type: CROSS_SELL_SUCCESS,
    data: response,
});
export const addCrossSellError = (error, meta = {}) => ({
    type: CROSS_SELL_ERROR,
    error: true,
    meta,
    payload: error,
});
export const addCrossSell = (options) => {
    const { cart, lineItemsAttributes } = options;
    return async (dispatch, _getState, { chord }) => {
        try {
            dispatch(addCrossSellRequest(lineItemsAttributes));
            const response = await chord.oms.crossSell(cart, null, {
                order: { lineItemsAttributes },
            });
            dispatch(addCrossSellSuccess(response));
            return response;
        }
        catch (error) {
            dispatch(addCrossSellError(error));
            throw error;
        }
    };
};
